import { render, staticRenderFns } from "./SingleBlogSeo.vue?vue&type=template&id=afe7bce0&scoped=true&"
import script from "./SingleBlogSeo.vue?vue&type=script&lang=js&"
export * from "./SingleBlogSeo.vue?vue&type=script&lang=js&"
import style0 from "./SingleBlogSeo.vue?vue&type=style&index=0&id=afe7bce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe7bce0",
  null
  
)

export default component.exports